export default "__VITE_ASSET__BuFj9cpd__"